import React from 'react'

const SelectionContext = React.createContext(null)

export const Provider = SelectionContext.Provider
export const Consumer = SelectionContext.Consumer

export default SelectionContext
